import { NgClass, NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { Params, RouterLink } from '@angular/router';
import { SvgComponent } from '@shared/components/svg';

@Component({
  selector: 'app-button',
  imports: [RouterLink, NgTemplateOutlet, SvgComponent, NgClass],
  templateUrl: './button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.block]': 'isFullWidth()',
    '[class.w-full]': 'isFullWidth()',
  },
})
export class ButtonComponent {
  readonly label = input.required<string>();
  readonly url = input<string>();
  readonly queryParams = input<Params>({});
  readonly buttonDisabled = input(false);
  readonly isFullWidth = input(false);
  readonly isLoading = input(false);
  readonly theme = input<'ANIS' | 'WHITE'>('ANIS');
  readonly leftIconSrc = input<string>();
  readonly onButtonClick = output();
}
